import React from 'react';
import styles from './AppSwitch.module.less';

interface AppSwitchConfig {
  url?: string;
  width?: string | number;
  margin?: string | number;
}

interface AppSwitchProps {
  config: AppSwitchConfig;
}

const AppSwitch: React.FC<AppSwitchProps> = ({ config }) => {
  return (
    <div className={styles.container}>
      {config.url && (
        <img
          className={styles.image}
          src={config.url}
          style={{ width: config.width, margin: config.margin }}
          alt="App Switch"
        />
      )}
    </div>
  );
};

export default AppSwitch;
